import { render, staticRenderFns } from "./SiteTabLinks.vue?vue&type=template&id=40fbc5bc&"
import script from "./SiteTabLinks.vue?vue&type=script&lang=js&"
export * from "./SiteTabLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports